export default __webpack_public_path__ + "static/media/NFT5.0102dd2b.png";